import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[spxColumnHeader]',
})
export class ColumnHeaderDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
